export default function PHP() {
  return (
    <div>
      <h1>PHP</h1>
    </div>
  );
}
